import { Animal } from "../../../redux/animals/animals-types";
import { Deployment } from "../../../redux/deployments/deployments-types";

export enum OrderColumn {
  time_correction_sec = "time_correction_sec",
  device_time_utc = "device_time_utc",
  full_id = "full_id",
  serial = "serial",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export type OrderBy = {
  column: OrderColumn;
  order: OrderDirection;
};

type Warning = {
  is_time_corrected: boolean;
  high_drift: boolean;
};

export type TableRow = {
  warning: Warning;
  time_correction_sec: number | null;
  time_utc: string;
  device_time_utc: string;
  full_id: string;
  serial: string;
  stations: string[];
  deployments: Deployment[];
  sensor_value: string | "";
  sensor_unit: string | "";
  animal_name: string;
  animal_species: string;
  file_names: string[];
  // supporting fields used for display logic
  animals: Animal[];
  animal_conflict: boolean;
};
export type BaseColumnField = keyof TableRow;

export type ParsedCsvRow = {
  time_correction_sec: string;
  time_utc: string;
  device_time_utc: string;
  full_id: string;
  serial: string;
  sensor_value: string; // can be ""
  sensor_type: string; // can be ""
  files: string; // actually file ids
  animal_ids: string; // can be ""
  drift_sec_per_day?: string; //can be ""
  deployment_ids: string; // can be ""
};
